import React, {useState} from "react";
import {Account} from "../../../pages/master/interfaces/Account";

interface Column {
  name: string;
  width: string;
}

export type TableColumn = string | Column;

interface TableHeadProps {
  columns: TableColumn[];
  checkbox?: boolean | undefined;
  setSelectedAccounts?: (selectedAccounts: string[]) => void;
  data?: Account[];
}

export default function TableHead({columns, checkbox, setSelectedAccounts, data}: TableHeadProps) {

  const [check, setCheck] = useState(false);

  function setChange(e: React.ChangeEvent<HTMLInputElement>) {
    setCheck(e.target.checked);

    if (data && setSelectedAccounts) {
      if (e.target.checked) {
        setSelectedAccounts(data.map((account) => account.cus_no));
      } else {
        setSelectedAccounts([]);
      }
    }
  }

  return (
    <thead>
      <tr>
        {checkbox && (
          <td style={{
            fontWeight: 'bold',
            textAlign: 'center',
          }}>
            <input type="checkbox" checked={check} onChange={setChange} />
          </td>
        )}
        {columns.map((column, i) => (
          <td key={i} style={{
            fontWeight: 'bold',
            textAlign: 'center',
            width: typeof column === 'string' ? undefined : column.width
          }}>
            {typeof column === 'string' ? column : column.name}
          </td>
        ))}
      </tr>
    </thead>
  )
}